import { Table } from "@/features/Table";
import { type B1Metadata, b1_metadata_columns } from "./columns";
import { type FilterB1MetadataSchema, FilterB1Metadata } from "./filter";
import { useLocation } from "react-router";

const client = "b1-quantilia";
const table_name = "b1_metadata";

export const B1MetadataTable = () => {
  const location = useLocation();
  const baseUrl = location.pathname;

  return (
    <Table<B1Metadata, FilterB1MetadataSchema>
      label="B1 Metadata"
      client={client}
      table_name={table_name}
      columns={b1_metadata_columns}
      filter={<FilterB1Metadata />}
      disable_translations_request={true}
      actions={[
        {
          label: "actions.new",
          route: `${baseUrl}/new`,
        },
      ]}
    />
  );
};
